import { render, staticRenderFns } from "./SetNewPassword.vue?vue&type=template&id=2e0e9b9a"
import script from "./SetNewPassword.vue?vue&type=script&lang=js"
export * from "./SetNewPassword.vue?vue&type=script&lang=js"
import style0 from "./SetNewPassword.vue?vue&type=style&index=0&id=2e0e9b9a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports